export function sendEvent(url: string, event: Record<string, unknown>): void {
  const body = JSON.stringify({ batch: [event] });
  // text/plain is CORS-safelisted, so the request stays "simple" and skips the
  // OPTIONS preflight. The Worker parses JSON regardless of Content-Type.
  const blob = new Blob([body], { type: 'text/plain' });
  if (typeof navigator.sendBeacon === 'function' && navigator.sendBeacon(url, blob)) return;
  void fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body,
    credentials: 'omit',
    keepalive: true,
  }).catch(() => {});
}

export function uuid(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const array = new Uint32Array(2);
  crypto.getRandomValues(array);
  return `${Date.now()}-${array[0]}-${array[1]}`;
}
